import { ObjectSchema, mixed, number, object, ref, string } from "yup";
import { requiredString } from "../../data/yupConstants";
import {
  PasswordPolicySettingsViewModel,
  PortalAuthenticationResult,
} from "../../generated/data-contracts";
import {
  LoginType,
  ResCallback,
  IExtendedChangePasswordViewModel,
} from "../../models";

export const changePasswordFormValidation = (
  policies: PasswordPolicySettingsViewModel | null,
  forgotPassword: boolean,
  ctxUser: PortalAuthenticationResult | undefined,
  res: ResCallback,
): ObjectSchema<IExtendedChangePasswordViewModel> | undefined => {
  if (!policies) return undefined;
  const validationSchema: ObjectSchema<IExtendedChangePasswordViewModel> =
    object({
      oldPassword: string()
        .when([], {
          is: () => !forgotPassword,
          then: (schema) => schema.required(res("validation_FieldIsRequired")),
          otherwise: (schema) => schema.default("-"),
        })
        .defined(),
      password1: requiredString(res)
        .min(
          policies.minLength,
          res(
            "user_ChangePassword_validation_NotValid",
            policies.minLength.toString(),
          ),
        )
        .when([], {
          is: () => policies.requiredUppercaseAndLowercase,
          then: (schema) =>
            schema
              .matches(
                /^(?=.*[a-z])/,
                res("user_ChangePassword_validation_NotValid"),
              )
              .matches(
                /^(?=.*[A-Z])/,
                res("user_ChangePassword_validation_NotValid"),
              ),
        })
        .when([], {
          is: () => policies.requiredDigit,
          then: (schema) =>
            schema.matches(
              /^(?=.*\d)/,
              res("user_ChangePassword_validation_NotValid"),
            ),
        })
        .when([], {
          is: () => policies.requiredSymbol,
          then: (schema) =>
            schema.matches(
              /^(?=.*[^A-Za-z\d])/,
              res("user_ChangePassword_validation_NotValid"),
            ),
        })
        .when([], {
          is: () => policies.mustNotContainLogin,
          then: (schema) =>
            schema.test(
              "does-not-contains-login",
              res("user_ChangePassword_validation_NotValid"),
              (value) => {
                if (ctxUser != null && typeof ctxUser.login != "undefined") {
                  return (
                    value
                      .toLocaleLowerCase()
                      .indexOf(ctxUser.login.toLocaleLowerCase()) == -1
                  );
                } else {
                  return true;
                }
              },
            ),
        }),
      password2: requiredString(res).oneOf(
        [ref("password1")],
        res("user_ChangePassword_validation_passwordsDoNotMatch"),
      ),
      personId: number().defined(),
      personContactId: number().defined(),
      loginType: mixed<LoginType>().defined(),
      redirectUrl: string().defined(),
    });

  return validationSchema;
};
